import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { EnergyLabelUI } from "./EnergyLabelUI";

export const EnergyLabel = ({
  product,
  className,
  experiences,
}: Pick<StandardProps, "product" | "experiences"> & { className?: string }) => {
  const { variant } = useVariant(product);

  if (!variant.energy) {
    return null;
  }

  const {
    label,
    informationSheet,
    rating: { legacy, value },
  } = variant.energy;

  return (
    <EnergyLabelUI
      className={className}
      informationSheet={informationSheet || undefined}
      isLegacy={!!legacy}
      label={label || undefined}
      rating={value}
      openDrawerEvent={experiences.energyLabelOnOpenDrawerEvent as string}
      closeDrawerEvent={experiences.energyLabelOnCloseDrawerEvent as string}
    />
  );
};
